import { EventsClient } from "./clients";
import { EventType, ListService } from "@/types";

export const EventTypesService: ListService<EventType> = {
  async all() {
    return await EventsClient.get<EventType[]>("/event-types");
  },
};
